<template>
  <div id="following">
    <h2 class="header">กองทุนที่ลงทุนในทอง</h2>
    <list-item
      data-action="open_fund"
      data-listname="market_gold"
      :data-fundname="item.name"
      v-for="item in items"
      :key="item.id"
      :showBadge="false"
      :name="item.name"
      :date="item.data_date"
      :period="'1 Day'"
      :price="item.price"
      :change="item.percent"
      :action="navigateTo"
      :query="item"
      :goldStyle="'gold-style'"
    ></list-item>
    <div id="view-all">
      <a
        href="javascript:;"
        data-action="view_all_gold_fund"
        @click="viewAll()"
        class="view-indice"
      >ดูกองทุนที่ลงทุนในทองทั้งหมด</a>
    </div>
  </div>
</template>

<script>
import ListItem from "../../commons/ListItem";
import { apiFundFilter } from "../../../../store/api/fund";
import querystring from "querystring";

export default {
  components: {
    ListItem
  },
  data() {
    return {
      page: 20,
      defaultSize: 10,
      pageOffset: 1,
      items: [],
      objQuery: {}
    };
  },
  created() {
    this.getGoldFund();
  },
  methods: {
    async getGoldFund() {
      try {
        this.objQuery.size = 5;
        this.objQuery.type = ["general"];
        this.objQuery.category = "LC00002497";
        this.objQuery.period = "1D"
        const res = await apiFundFilter(querystring.stringify(this.objQuery));
        if (res && res.status == 200) {
          res.data.data.forEach(item => {
            this.items.push({
              id: item.mstar_id,
              name: item.thailand_fund_code,
              data_date: item.nav_date,
              period: res.data.period,
              percent: item.return_perf,
              price: item.nav
            });
          });
        }
      } catch (error) {
        throw new Error(error);
      }
    },
    viewAll() {
      this.$router.push({
        name: "miniapp-market-fund",
        query: { type: ["general"], category: "LC00002497", period: "1D", activeMenu: "miniapp-market-fund" }
      });
    },
    navigateTo({ id }) {
      this.$router.push({ name: "miniapp-fund-quote", query: { id: id } });
    }
  }
};
</script>

<style lang="scss" scoped>
#following {
  .header {
    margin-top: 40px;
    margin-bottom: 16px;
    i {
      color: $color-normal-text;
    }
    display: inline-block;
    @extend %font-size-m;
    font-weight: bold;
    color: $color-normal-text;
  }
  #view-all {
    margin: 16px 0;
    text-align: center;
    a {
      text-decoration: none;
      border-bottom: 1px solid #999999;
      @extend %font-size-ss;
      font-weight: bold;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #999999;
    }
  }
}
</style>